import React, { useEffect, useMemo } from 'react';
import {
  Redirect,
  Route,
  Switch,
  generatePath,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import { Spin } from 'antd';

import { AdministrationTabs } from './components/AdministationTabs/AdministrationTabs';
import { AdminInfo } from './pages/AdministrationInfo/AdminInfo';

import { adminPaths } from './constants/paths';
import useCompanies from '../../queries/useCompanies';
import {
  getCompanyFromUrlOrSavedOrFirst,
  saveSelectedCompanyId,
} from '../../helpers/companyStorage';

import Toolbar from '../HousingStock/components/common/Toolbar/Toolbar';
import { SelectCompanyBase } from '../HousingStock/components/ui/MainHeader/components/SelectCompany';

import styles from './Administration.module.scss';
import { WorkSchedule } from './pages/WorkSchedule/WorkSchedule';

export const Administration = () => {
  const history = useHistory();
  const location = useLocation();

  const companyMatch = useRouteMatch({
    path: adminPaths.withCompany(':companyId'),
  });
  const companyInfoMatch = useRouteMatch({
    path: adminPaths.companyInfo(':companyId'),
  });
  const workScheduleMatch = useRouteMatch({
    path: adminPaths.workSchedule(':companyId'),
  });
  /*
  const companyTestMatch = useRouteMatch({
    path: adminPaths.companyTest(':companyId'),
  });
  */

  const companyIdParam = companyMatch?.params.companyId;
  const companyIdFromPath = companyIdParam ? Number(companyIdParam) : null;

  const companiesQuery = useCompanies();

  const currentCompany = useMemo(
    () =>
      getCompanyFromUrlOrSavedOrFirst(companiesQuery.data, companyIdFromPath),
    [companiesQuery.data, companyIdFromPath]
  );

  const currentCompanyId = currentCompany?.id;
  useEffect(() => {
    if (currentCompanyId) {
      saveSelectedCompanyId(currentCompanyId);
    }
  }, [currentCompanyId]);

  if (!companyIdParam) {
    return companiesQuery?.isFetching ? (
      <div className={styles.root}>
        <Spin className={styles.rootSpin} />
      </div>
    ) : companiesQuery?.data?.length ? (
      <Redirect to={adminPaths.companyInfo(currentCompany.id)} />
    ) : (
      <div>Нет доступных компаний</div>
    );
  }

  if (currentCompany && currentCompany.id !== companyIdFromPath) {
    return (
      <Redirect
        to={{
          ...location,
          pathname: adminPaths
            .withCompany(currentCompany.id)
            .concat(location.pathname.slice(companyMatch.url.length)),
        }}
      />
    );
  }

  const handleCompanyChange = ({ companyId }) => {
    if (companyId === currentCompany?.id) {
      return;
    }
    const companyRelatedPaths = [
      companyInfoMatch,
      workScheduleMatch,
      // companyTestMatch,
    ];
    const [currentMatch] = companyRelatedPaths.filter(Boolean);
    if (!currentMatch) {
      return;
    }
    saveSelectedCompanyId(companyId);
    const newPath = generatePath(currentMatch.path, {
      ...currentMatch.params,
      companyId,
    });
    history.push(newPath);
  };

  const renderCompanySelect = ({ disabled = false, btnProps = null } = {}) => (
    <SelectCompanyBase
      currentCompany={currentCompany}
      companies={companiesQuery?.data || []}
      onChange={handleCompanyChange}
      btnProps={btnProps}
      disabled={disabled}
    />
  );

  const renderToolbar = ({
    actions = null,
    disableCompanyChange = false,
    hideCompanySelect = false,
  } = {}) => (
    <Toolbar isHeader={false} background="light" className={styles.toolbar}>
      <AdministrationTabs companyId={companyIdFromPath} />
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          flexWrap: 'wrap-reverse',
        }}
      >
        {Boolean(actions) && <div>{actions}</div>}
        {!hideCompanySelect && (
          <div style={{ marginLeft: 'auto' }}>
            {renderCompanySelect({ disabled: disableCompanyChange })}
          </div>
        )}
      </div>
    </Toolbar>
  );

  return (
    <div className={styles.root}>
      {currentCompany ? (
        <Switch>
          <Route
            path={adminPaths.root}
            exact
          >
            <Redirect to={adminPaths.companyInfo(currentCompany.id)} />
          </Route>
          <Route path={adminPaths.companyInfo(currentCompany.id)}>
            <AdminInfo
              companyId={currentCompany.id}
              renderToolbar={renderToolbar}
            />
          </Route>
          <Route path={adminPaths.workSchedule(currentCompany.id)}>
            <WorkSchedule
              companyId={currentCompany.id}
              renderCompanySelect={renderCompanySelect}
              renderToolbar={renderToolbar}
            />
          </Route>
          {/*
          <Route path={adminPaths.companyTest(currentCompany.id)}>
            <div>{renderToolbar()}</div>
            <div>TEST path</div>
          </Route>
        */}
        </Switch>
      ) : null}
    </div>
  );
};

Administration.propTypes = {};
